import SimeraDashboard from '../../SimeraDashboard/SimeraDashboard';
import InternalDashboardPages from '../../../constants/InternalDashboardPages';

const SimeraDashboardScreen = () => {
  return <SimeraDashboard page={InternalDashboardPages.POSITIONS} />;
};

export default SimeraDashboardScreen;
